import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/hearts.svg'


const _hoisted_1 = { class: "loginScreen" }
const _hoisted_2 = { class: "popUpWindow" }
const _hoisted_3 = { class: "stepHeader" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "primaryShort" }, null, -1)
const _hoisted_5 = ["alt"]
const _hoisted_6 = { class: "subTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("register.thank_you")), 1)
      ]),
      _hoisted_4,
      _createElementVNode("img", {
        src: _imports_0,
        alt: _ctx.$t('accessibility.register.thank_you'),
        class: "hearts"
      }, null, 8, _hoisted_5),
      _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("register.thank_you_new_user")), 1),
      _createVNode(_component_Button, {
        "event-name": "loginTitleButton",
        "event-from": "/register/success",
        class: "defaultButton",
        label: _ctx.$t(`global.login`),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'Login' })))
      }, null, 8, ["label"])
    ])
  ]))
}